/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import range from 'lodash/range';

import { Select, SelectOption } from 'sarsaparilla';
import type { Reservation, AvailabilityEntry, PermitType } from '../../../types/permit';

export const formatPrice = (value: number) => `$${(value / 100000).toFixed(2)}`;

interface PermitsTypes {
    onChangeReservationHandler: (id: string, event: HTMLSelectElement['value']) => void;
    permits: Array<PermitType>;
    reservations: Array<Reservation>;
    reservation?: Reservation | null;
    availability: Record<string, Partial<AvailabilityEntry>>;
}

export default function Permits({
    onChangeReservationHandler,
    reservation: haveReservation,
    permits,
    availability,
    reservations,
}: PermitsTypes) {
    if (!permits || !isEmpty(haveReservation)) {
        return null;
    }
    const sortedPermits = orderBy(permits, ['name'], ['asc']);
    return (
        <div className="tp-permits">
            <table className="tp-permits-table">
                <thead>
                    <tr>
                        <th scope="col">Permit Name</th>
                        <th scope="col">Max # Of Trees</th>
                        <th scope="col">Price</th>
                        <th scope="col"># Of Trees</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedPermits?.map((permit) => {
                        const { id, max_trees, name } = permit;
                        const unlimitedQuota =
                            availability[permit?.id]?.availability?.unlimited;
                        const quota =
                            availability[permit?.id]?.availability?.available || 0;
                        const reservation = reservations.find((item) => {
                            return item?.permit?.id === id;
                        });
                        const value = reservation?.quantity || 0;
                        const maxQuota =
                            quota < max_trees && !unlimitedQuota ? quota : max_trees;
                        const price = availability[permit?.id]?.price || 0;
                        return (
                            <tr key={id}>
                                <td>
                                    <div className="tp-permit-name">{name}</div>
                                    <div className="tp-permit-max">
                                        Max # of Trees: {maxQuota}
                                    </div>
                                    <div className="tp-permit-price">
                                        {formatPrice(price)} / per tree
                                    </div>
                                </td>
                                <td>{maxQuota}</td>
                                <td>{formatPrice(price)} / per tree</td>
                                {quota > 0 || unlimitedQuota ? (
                                    <td>
                                        <Select
                                            id={id}
                                            label="Number Of Trees"
                                            isLabelVisible={false}
                                            defaultValue=""
                                            value={`${value}`}
                                            onChange={(e) => {
                                                onChangeReservationHandler(
                                                    id,
                                                    e?.target?.value
                                                );
                                            }}
                                        >
                                            {range(0, maxQuota + 1).map((i) => {
                                                return (
                                                    <SelectOption
                                                        value={`${i}`}
                                                        key={`${id}-${i}`}
                                                    >
                                                        {i}
                                                    </SelectOption>
                                                );
                                            })}
                                        </Select>
                                    </td>
                                ) : (
                                    <td>
                                        <span>Sold Out</span>
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
